import React from "react";

function YearFilter({ selectedYear, handleYearChange }) {
  return (
    <div className="col-sm-3">
      <select
        className="form-select"
        value={selectedYear}
        onChange={handleYearChange}
      >
        <option value="" disabled>
          Select Year
        </option>
        {[0, 1, 2].map((i) => {
          const year = new Date().getFullYear() - i;
          return (
            <option key={year} value={year}>
              {year}
            </option>
          );
        })}
      </select>
    </div>
  );
}

export default YearFilter;
